(function () {
  function getVariantsData() {
    const el = document.getElementById('uvp-variants-json');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent).variants;
    } catch {
      return null;
    }
  }

  function getCurrentVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function updateUVP() {
    const wrapper = document.querySelector('.uvp-wrapper');
    const percentEl = document.querySelector('.uvp-percent');
    if (!wrapper || !percentEl) return;

    const variants = getVariantsData();
    const currentId = getCurrentVariantId();

    if (!variants || !currentId) {
      wrapper.hidden = true;
      return;
    }

    const variant = variants.find(v => v.id === currentId);
    if (!variant || !variant.uvp) {
      wrapper.hidden = true;
      return;
    }

    // Liquid rendert Preise in Cent → /100 für Vergleich mit UVP (Euro)
    const price = variant.price / 100;
    const comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
    const uvp = parseFloat(variant.uvp);

    // Nur anzeigen wenn UVP > VK UND (kein Streichpreis ODER UVP > Streichpreis)
    const showUvp = uvp > price && (comparePrice === null || uvp > comparePrice);

    if (!showUvp) {
      wrapper.hidden = true;
      return;
    }

    const percent = Math.round(((uvp - price) / uvp) * 100);
    if (percent <= 0) {
      wrapper.hidden = true;
      return;
    }

    percentEl.textContent = percent + ' %';

    const amountEl = wrapper.querySelector('.uvp-amount');
    if (amountEl) {
      const uvpFormatted = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(uvp);
      amountEl.textContent = uvpFormatted;
    }

    wrapper.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', updateUVP);
  document.addEventListener('change', updateUVP);
  document.addEventListener('variant:change', updateUVP);
  setTimeout(updateUVP, 300);
})();